import styled from 'styled-components';

export const StyledId = styled.span<{ wizard?: boolean }>`
  font-size: ${({ theme }) => `${theme.fonts.sizes.default}`};
  font-weight: ${({ theme }) => `${theme.fonts.weight.regular}`};
  text-align: left;
  display: inline-block;
  &::after {
    font-size: ${({ theme }) => `${theme.fonts.sizes.default}`};
    font-weight: ${({ theme }) => `${theme.fonts.weight.regular}`};
    animation: animate-wizard 6s infinite;
    content: '[WIZARD]';
    display: ${({ wizard }) => (wizard ? 'inline-block' : 'none')};
  }

  @keyframes animate-wizard {
    80% {
      content: '[HARRY]';
    }
  }
`;

export const StyledNickname = styled.span<{ wizard?: boolean }>`
  font-size: ${({ theme }) => `${theme.fonts.sizes.default}`};
  font-weight: ${({ theme }) => `${theme.fonts.weight.regular}`};
  text-align: left;
  display: ${({ wizard }) => (wizard ? 'none' : 'inline-block')};
`;
